import { FilterParams } from "@components/Features/catalog/catalog-utils";
import { useGetOffersQuery } from "@app/store/offersApi";

export const usePreviewQuantity = (updateFilters: FilterParams) => {
    const {
        data: updatePreviewQntData,
        isLoading: updatePreviewQntIsLoading,
        isFetching: updatePreviewQntIsFetching
    } = useGetOffersQuery({
        ...updateFilters
    });

    return {
        updatePreviewQntData,
        updatePreviewQntIsLoading,
        updatePreviewQntIsFetching
    };
};